import type { UploaderMethodProps } from 'src/app/shared/components/imageUpload';

import type { ImageData } from './types';

// eslint-disable-next-line complexity
export async function saveImage(uploader: UploaderMethodProps | null): Promise<ImageData> {
	try {
		if (!uploader) throw new Error('Uploader is null');

		const { upload } = uploader;
		const result = await upload();

		if ((result?.failed?.length ?? 0) > 0) {
			throw new Error(result?.failed?.[0]?.error ?? 'Upload failed');
		}

		if (!result?.successful?.[0]?.uploadURL) {
			throw new Error('Bad URL returned from upload');
		}
		return result.successful[0];
	} catch (e: unknown) {
		const message = e instanceof Error ? e.message : 'Unexpected error';
		throw new Error(message);
	}
}
